<template>
	<div class="order_box">
		<div class="calendar">
			<div class="title">My events calendar</div>
			
			<div class="calendar_main">
				<div class="select_list flex">
					<div class="item flex align-center justify-between">
						<el-select v-model="course_age_id" clearable  placeholder="for any age" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in ageList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="timeStatus" clearable   placeholder="Any time" size="small"  @change="changeTime">
						   <el-option
						     v-for="item in timeOptions"
						     :key="item.value"
						     :label="item.label"
						     :value="item.value">
						   </el-option>
						</el-select>
						
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="course_shop_id" clearable  placeholder="Any Venue" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in shopList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="course_type_id" clearable  placeholder="Any class" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in classifyList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="selectWeek" clearable  placeholder="Any day" size="small"  @change="changeWeek">
						   <el-option
						     v-for="item in selectWeekList"
						     :key="item.id"
						     :label="item.label"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
				</div>
				<div class="calendar_header flex align-center justify-between">
					<div class="left flex align-center" @click="lastMonth">
						<img src="../../../assets/images/icon/left.png" alt="">
						<span>Last week</span>
					</div>
					<div class="date">{{showTime1}}-{{showTime2}}</div>
					<div class="right flex align-center" @click="nextMonth">
						<span>Next week</span>
						<img src="../../../assets/images/icon/right.png" alt="">
					</div>
				</div>
				<div class="weeklist">
					<ul class="weekName flex align-center justify-between">
						<li class="item" v-for="(item,index) in weekList" :key="index">
							<span>{{item}}</span>
							<span class="day">{{weekDayList[index]}}</span>
						</li>
					</ul>
					<div class="course_list flex  justify-between">
						<div class="day_item" v-for="(item,index) in courseList" :key="index">
							<div>
								<div class="item" v-for="(ite,ind) in item.course" :key="ind" >
									<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
									<div class="place line_two">{{ite.course_shop_name}}</div>
									<div class="info" :style="{'background':ite.color}">
										<div class="name">{{ite.course_type_name}} </div>
										<div class="age">{{ite.course_age_name}}</div>
									</div>
									<!-- <div class="tag" v-if="num == 0">waiting list</div> -->
									<!-- <div class="tag_list flex align-center" v-else-if="ite.is_try == 1">
										<div class="tag" @click="openIntro(ite.id)">试课</div>
										<div class="tag" @click="ensureOrder(ite.course_id)">立即订课</div>
									</div> -->
									<div class="tag" v-if="ite.isShow" @click="changeCourse(ite)">Reschedule</div>
								</div>
								<div class="add_course" @click="addCourse">
									<img src="../../../assets/images/icon/add.png" alt="">
									<div class="name">add a class</div>
								</div>
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
		<div class="course_order">
			<div class="header">
				<div class="title">Booking History</div>
				<!-- <div class="search">
					<input type="text" placeholder="请输入">
					<img src="../../../assets/images/icon/search.png" alt="">
				</div> -->
			</div>
			<div class="tabel_box">
				<el-table
				    :data="tableData"
				    stripe
				    style="width: 100%">
				    <el-table-column
				      prop="date"
				      label="">
					  <template slot-scope="scope">
						 <img :src="imgBaseUrl + scope.row.product.image" alt="">
						</template>
				    </el-table-column>
				    <el-table-column
				      prop="product.name"
				      label="Class">
				    </el-table-column>
				    <el-table-column
						width="140"
						 prop="createtime"
				      label="Order Time">
						<!-- <template slot-scope="scope">
						 <div>{{scope.row.product.start_date}}</div>
						</template> -->
				    </el-table-column>
					<!-- <el-table-column
					  prop="time"
					  width="150"
					  label="Time">
					  <template slot-scope="scope">
					   <div>{{scope.row.product.start_time}}-{{scope.row.product.end_time}}</div>
					  </template>
					</el-table-column> -->
					<!-- <el-table-column
					  prop="name"
					  label="操作人">
					</el-table-column> -->
					<el-table-column
					  prop=""
					  label="Child">
					  <template slot-scope="scope">
					   <span >{{scope.row.product.child.child_first_name}} {{scope.row.product.child.child_last_name}}</span>
					  </template>
					</el-table-column>
					<el-table-column
					  prop="order_status_txt"
					  width="200"
					  label="Payment Status">
					</el-table-column>
					<el-table-column
					  prop="pay_type"
					  label="Method">
					</el-table-column>
					<el-table-column
					  prop="total_price"
					  label="Amount">
					  <template slot-scope="scope">
						<div >£{{scope.row.total_price}}</div>
						</template>
					</el-table-column>
					<el-table-column
					  prop="combo_num"
					  label="Credits used">
					</el-table-column>
					<el-table-column
					  prop="date"
					  label="">
					  <template slot-scope="scope">
						 <div class="detail" @click="toCourseDetail(scope.row)">Details</div>
						</template>
					</el-table-column>
				  </el-table>
			</div>
			<div class="pages">
				<el-pagination
				      @size-change="handleSizeChange"
				      @current-change="handleCurrentChange"
				      :current-page="currentPage"
				      :page-sizes="[100, 200, 300, 400]"
				      :page-size="pageSize"
				      layout="prev, pager, next,sizes, jumper"
					  :total="total"
				      >
				    </el-pagination>
			</div>
			<!-- <div class="bottom_logo">
				<img src="../../../assets/images/icon/shou.png" alt="">
			</div> -->
		</div>
		
		<div class="model" v-if="isChange" @click="isChange = false">
			<div class="model_calendar" @click.stop="">
				<div class="title">Booked class:{{changeCourseName}} (Please select the class in this calander you'd like to rescheule to)</div>
				<div class="calendar_main">
					<div class="select_list flex align-center">
						<div class="name">*Reschedule to:</div>
						<div class="search">
							<input type="text" placeholder=" Search">
							<img src="../../../assets/images/icon/search.png" alt="">
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="second_course_age_id" clearable  placeholder="for any age" size="small"  @change="second_getCourseList">
							   <el-option
							     v-for="item in ageList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="second_timeStatus" clearable   placeholder="Any time" size="small"  @change="second_changeTime">
							   <el-option
							     v-for="item in timeOptions"
							     :key="item.value"
							     :label="item.label"
							     :value="item.value">
							   </el-option>
							</el-select>
							
						</div>
						<div class="item flex align-center justify-between">
							<el-select v-model="second_course_shop_id" clearable  placeholder="Any Venue" size="small"  @change="second_getCourseList">
							   <el-option
							     v-for="item in shopList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center ustify-between">
							<el-select v-model="second_course_type_id" clearable  placeholder="Any class" size="small"  @change="second_getCourseList">
							   <el-option
							     v-for="item in classifyList"
							     :key="item.id"
							     :label="item.name"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						<div class="item flex align-center ustify-between">
							<el-select v-model="second_selectWeek" clearable  placeholder="Any class" size="small"  @change="second_changeWeek">
							   <el-option
							     v-for="item in selectWeekList"
							     :key="item.id"
							     :label="item.label"
							     :value="item.id">
							   </el-option>
							</el-select>
						</div>
						
					</div>
					<div class="calendar_header flex align-center justify-between">
						<div class="left flex align-center" @click="second_lastMonth">
							<img src="../../../assets/images/icon/left.png" alt="">
							<span>Last week</span>
						</div>
						<div class="date">{{second_showTime1}}-{{second_showTime2}}</div>
						<div class="right flex align-center" @click="second_nextMonth">
							<span>Next week</span>
							<img src="../../../assets/images/icon/right.png" alt="">
						</div>
					</div>
					<div class="weeklist">
						<ul class="weekName flex align-center justify-between">
							<li class="item" v-for="(item,index) in weekList" :key="index">
								<span>{{item}}</span>
								<span class="day">{{second_weekDayList[index]}}</span>
							</li>
						</ul>
						<div class="course_list flex  justify-between">
							<div class="day_item" v-for="(item,index) in second_courseList" :key="index">
								<div>
									<div class="item" v-for="(ite,ind) in item.course" :key="ind" >
										<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
										<div class="place line_two">{{ite.course_shop_name}}</div>
										<div class="info" :style="{'background':ite.color}">
											<div class="name">{{ite.course_type_name}} </div>
											<div class="age">{{ite.course_age_name}}</div>
										</div>
										<div class="tag" v-if="ite.is_expired" @click="toChangeCourse(ite)">Select</div>
										
									</div>
									
								</div>
							</div>
						</div>
						
					</div>
					<!-- <div class="send flex align-center justify-center">
						<img v-if="selectSend" src="../../../assets/images/icon/select_active.png" alt="">
						<img v-else src="../../../assets/images/icon/select.png" alt="">
						<div>发送邮件通知</div>
					</div> -->
					<!-- <div class="submit_btn" >确认</div> -->
				</div>
				
				
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				weekList:['Mon','Tue','Wed','Thur','Fri','Sat','Sun'],
				total:10,
				secondTotal:10,
				currentPage:1,
				secondCurrentPage:1,
				pageSize:0,
				secondPageSize:0,
				productData:[],
				tableData: [],
				// 日历
				classifyList:[],
				shopList:[],
				ageList:[],
				course_age_id:'',
				course_shop_id:'',
				course_type_id:'',
				start_time:'',
				start_time1:'',
				end_time1:'',
				end_time:'',
				showTime1:'',
				showTime2:'',
				end_date:'',
				start_date:'',       
				weekStartDay:'',     //一周开始事件
				weekDayList:[],     //每周日期列表
				courseList:[],     //日历课程列表
				timeStatus:'',
				timeOptions:[{
					value:0,
					label:'AM'
				},{
					value:1,
					label:'PM'
				}],
				selectWeekList:[{id:0,label:'Monday'},{id:1,label:'Tuesday'},{id:2,label:'Wednesday'},{id:3,label:'Thursday'},{id:4,label:'Friday'},{id:5,label:'Saturday'},{id:6,label:'Sunday'}],
				selectWeek:'',
				select_date:'',
				// 改课日历
				second_course_age_id:'',
				second_course_shop_id:'',
				second_course_type_id:'',
				second_start_time:'',
				second_start_time1:'',
				second_end_time1:'',
				second_end_time:'',
				second_showTime1:'',
				second_showTime2:'',
				second_end_date:'',
				second_start_date:'',       
				weekStartDay:'',     //一周开始事件
				second_weekDayList:[],     //每周日期列表
				second_courseList:[],     //日历课程列表
				second_timeStatus:'',
				second_selectWeek:'',
				second_select_date:'',
				changeCourseName:'',
				isChange:false,
				selectSend:false,
				changeCourseId:'',
				cpuId:'',
				select_date_index:-1,
				second_select_date_index:-1,
			}
		},
		created(){
			this.getClassify();
			this.getShopList();
			this.getAgeList();
			this.getWeek(new Date());
			
			this.getCourseOrder();
		},
		methods:{
			
			toCourseDetail(item){
				this.$router.push({path:'/home/userInfo/eventOrderDetail',query:{order_sn:item.order_sn}})
			},
			addCourse(){
				this.$router.push({path:'/home/event',query:{date:this.start_date}})
			},
			changeCourse(item){
				this.isChange = true;
				this.changeCourseName = item.course_type_name;
				this.changeCourseId = item.id;
				this.cpuId = item.cpu_id;
				this.second_getWeek(new Date());
			},
			toChangeCourse(item){
				var params = {
					cpu_id:this.cpuId,
					change_id:item.id,
				}
				this.$api.post('Events_order/change',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Succesfully rescheduled'
						})
						this.isChange = false;
						this.getCourseList()
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			getCourseOrder(){
				this.$api.post('Events_order/getOrderList',{page:this.currentPage},res=>{
					if(res.code == 1){
						res.data.data.forEach((item,index)=>{
							item.product.start_time = item.product.start_time.substring(0,5)
							item.product.end_time = item.product.end_time.substring(0,5);
							item.order_status_txt = item.order_status == 0 ? 'payment outstanding' : item.order_status == 1 ? 'paid' :item.order_status == -1 ? 'cancelled' : ''
						})
						this.tableData = res.data.data;
						this.total = res.data.total;
						this.pageSize = res.data.per_page;
					}
				})
			},
			
			handleCurrentChange(val){
				this.currentPage = val;
				this.getCourseOrder()
			},
			
			handleSizeChange(e){
				console.log(e)
			},
			changeTime(e){
				console.log(e)
				if(this.timeStatus == 0){
					this.start_time = '00:00';
					this.end_time = '12:00'
				}else{
					this.start_time = '12:00';
					this.end_time = '24:00'
				}
				this.getCourseList()
			},
			changeWeek(e){
				var start = this.start_date.substring(this.start_date.length-2);
				this.select_date_index = e;
				if(this.weekDayList[e] > start){
					this.select_date = this.start_date.substring(0,this.start_date.length-2)+this.weekDayList[e]
				}else{
					this.select_date = this.end_date.substring(0,this.end_date.length-2)+this.weekDayList[e]
				}
				this.getCourseList()
			},
			
			getWeek(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.weekDayList = weekList;
				this.showTime1 = day1+'/'+month1+'/'+year1;
				this.showTime2 = day2+'/'+month2+'/'+year2;
				this.start_date = year1+'-'+month1+'-'+day1;
				this.end_date = year2+'-'+month2+'-'+day2;
				var start = this.start_date.substring(this.start_date.length-2);
				if(this.select_date_index>=0){
					if(this.weekDayList[this.select_date_index] > start){
						this.select_date = this.start_date.substring(0,this.start_date.length-2)+this.weekDayList[this.select_date_index]
					}else{
						this.select_date = this.end_date.substring(0,this.end_date.length-2)+this.weekDayList[this.select_date_index]
					}
				}
				this.getCourseList()
			},
			lastMonth(){
				var date = new Date(this.start_date).getTime();
				date = date - 24* 60*60*1000;
				this.getWeek(new Date(date))
			},
			nextMonth(){
				var date = new Date(this.end_date).getTime();
				date = date + 24* 60*60*1000;
				this.getWeek(new Date(date))
			},
			getCourseList(){
				var params = {
					start_date:this.start_date,
					end_date:this.end_date,
					start_time:this.start_time,
					end_time:this.end_time,
					course_age_id:this.course_age_id,
					course_type_id:this.course_type_id,
					course_shop_id:this.course_shop_id,
					date:this.select_date
				}
				this.$api.post('Events/getMyCourseList',params,res=>{
					if(res.code == 1){
						var nowDate = new Date().getTime();
						res.data.forEach((item,index)=>{
							var itemDate = item.date;
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									var courseDate = itemDate+' '+ite.start_time;
									courseDate = new Date(courseDate).getTime();
									if(nowDate > courseDate){
										ite.isShow = false
									}else{
										ite.isShow = true
									}
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.courseList = res.data;
					}
				})
			},
			second_changeTime(e){
				console.log(e)
				if(this.second_timeStatus == 0){
					this.second_start_time = '00:00';
					this.second_end_time = '12:00'
				}else{
					this.second_start_time = '12:00';
					this.second_end_time = '24:00'
				}
				this.second_getCourseList()
			},
			second_changeWeek(e){
				var start = this.second_start_date.substring(this.second_start_date.length-2);
				this.second_select_date_index =e;
				if(this.second_weekDayList[e] > start){
					this.second_select_date = this.second_start_date.substring(0,this.second_start_date.length-2)+this.second_weekDayList[e]
				}else{
					this.second_select_date = this.second_end_date.substring(0,this.second_end_date.length-2)+this.second_weekDayList[e]
				}
				this.second_getCourseList()
			},
			
			second_getWeek(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.second_weekDayList = weekList;
				this.second_showTime1 = day1+'/'+month1+'/'+year1;
				this.second_showTime2 = day2+'/'+month2+'/'+year2;
				this.second_start_date = year1+'-'+month1+'-'+day1;
				this.second_end_date = year2+'-'+month2+'-'+day2;
				var start = this.second_start_date.substring(this.second_start_date.length-2);
				if(this.second_weekDayList[this.second_select_date_index] > start){
					this.second_select_date = this.second_start_date.substring(0,this.second_start_date.length-2)+this.second_weekDayList[this.second_select_date_index]
				}else{
					this.second_select_date = this.second_end_date.substring(0,this.second_end_date.length-2)+this.second_weekDayList[this.second_select_date_index]
				}
				this.second_getCourseList()
			},
			second_lastMonth(){
				var date = new Date(this.second_start_date).getTime();
				date = date - 24* 60*60*1000;
				this.second_getWeek(new Date(date))
			},
			second_nextMonth(){
				var date = new Date(this.second_end_date).getTime();
				date = date + 24* 60*60*1000;
				this.second_getWeek(new Date(date))
			},
			second_getCourseList(){
				var params = {
					start_date:this.second_start_date,
					end_date:this.second_end_date,
					start_time:this.second_start_time,
					end_time:this.second_end_time,
					course_age_id:this.second_course_age_id,
					course_type_id:this.second_course_type_id,
					course_shop_id:this.second_course_shop_id,
					course_products_id:this.changeCourseId,
					date:this.second_select_date
				}
				this.$api.post('Events/getChangeList',params,res=>{
					if(res.code == 1){
						res.data.forEach((item,index)=>{
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.second_courseList = res.data;
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
						this.isChange= false;
						// this.second_courseList = []
					}
				})
			},
			getClassify(){
				this.$api.post('Events/getCourseType',{},res=>{
					if(res.code == 1){
						this.classifyList = res.data;
					}
				})
			},
			getShopList(){
				this.$api.post('Events/getCourseShop',{},res=>{
					if(res.code == 1){
						this.shopList = res.data;
					}
				})
			},
			getAgeList(){
				this.$api.post('Events/getCourseAge',{},res=>{
					if(res.code == 1){
						this.ageList = res.data;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.order_box{
		padding: 30px 20px;
	}
	.calendar{
		width: 1240px;
		background: #5C707A;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		padding: 20px;
		.title{
			padding-top: 40px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #FFFFFF;
		}
		.type_list{
			.item{
				width: 200px;
				height: 60px;
				border: 2px solid #FFFFFF;
				border-radius: 5px 0px 0px 5px;
				line-height: 60px;
				text-align: center;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #FFFFFF;
				&.active{
					background: #FFFFFF;
					color: #5C707A;
				}
			}
		}
		.calendar_main{
			width: 1200px;
			margin: 0 auto;
			padding-top: 40px;
			.select_list{
				.item{
					// padding: 0 20px;
					height: 60px;
					background: #FFFFFF;
					border-radius: 10px;
					margin-right: 40px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					img{
						width: 27px;
						height: 15px;
						margin-left: 10px;
					}
				}
			}
			::v-deep .el-select-dropdown__list{
				padding: 15px 0;
			}
			::v-deep .el-select{
				// width: 100%;
				height: 100%;
			}
			::v-deep .el-input.el-input--suffix{
				height: 100%;
			}
			::v-deep .el-input__icon{
				line-height: 56px;
			}
			::v-deep .el-input--suffix .el-input__inner{
				height: 100%;
				font-size: 18px;
				background-color: #F7F2EB;
				border: none;
				color: #282E30;
			}
			::v-deep .el-time-spinner__item{
				text-align: center;
			}
			.calendar_header{
				margin-top: 30px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #FFFFFF;
				img{
					width: 25px;
					height: 26px;
				}
				.left{
					cursor: pointer;
					span{
						margin-left: 10px;
					}
				}
				.right{
					cursor: pointer;
					span{
						margin-right: 10px;
					}
				}
			}
			.weeklist{
				margin-top: 30px;
				.weekName{
					.item{
						width: 150px;
						height: 60px;
						border: 1px solid #FFFFFF;
						border-radius: 10px;
						padding-left: 30px;
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #FFFFFF;
						line-height: 60px;
						.day{
							margin-left: 15px;
						}
					}
				}
				.course_list{
					margin-top: 20px;
					.day_item{
						width: 150px;
						.item{
							width: 100%;
							height: 200px;
							padding-top: 5px;
							background: #FFFFFF;
							font-size: 16px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #282E30;
							line-height: 30px;
							text-align: center;
							margin-top: 20px;
							border-radius: 10px;
							overflow: hidden;
							.time{
								text-align: center;
								
							}
							.place{
								text-align: center;
								height: 60px;
							}
							.info{
								height: 60px;
								background: #C98B2C;
								line-height: 26px;
								text-align: center;
								.name{
									text-align: center;
									height: 30px;
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}
								.age{
									font-size: 12px;
									text-align: center;
								}
								&.red{
									background: #BF5F49;
								}
							}
							.tag{
								width: 90px;
								height: 26px;
								border: 1px solid #000000;
								border-radius: 13px;
								font-size: 12px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #000000;
								text-align: center;
								line-height: 26px;
								margin: 7px auto 0;
								cursor: pointer;
							}
						}
					}
				}
				.add_course{
					width: 150px;
					height: 168px;
					background: #FFFFFF;
					border-radius: 10px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					margin-top: 20px;
					cursor: pointer;
					img{
						width: 41px;
						height: 41px;
					}
					.name{
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						margin-top: 15px;
					}
				}
			}
		}
	}
	.course_order{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		margin-top: 20px;
		padding: 30px 36px 30px 24px;
		.header{
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
			}
			.search{
				width: 386px;
				height: 50px;
				background: #F7F2EB;
				border: 1px solid #5C707A;
				border-radius: 25px;
				position: relative;
				img{
					position: absolute;
					width: 33px;
					height: 33px;
					right: 20px;
					top: 50%;
					transform: translateY(-50%);
				}
				input{
					width: 100%;
					height: 100%;
					line-height: 50px;
					padding: 0 70px 0 20px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 200;
					color: #5C707A;
				}
			}
		}
		.tabel_box{
			margin-top: 30px;
			img{
				width: 60px;
				height: 60px;
				border-radius: 10px;
			}
		}
		::v-deep .el-table__header tr{
			background-color: #5C707A;
		}
		::v-deep .el-table th.el-table__cell{
			background-color: #5C707A;
		}
		::v-deep .el-table tr{
			background-color: #F7F2EB;
		}
		::v-deep .el-table__row{
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
		}
		::v-deep .el-table__row .detail{
			color: #5C707A;
			cursor: pointer;
		}
		::v-deep .el-table thead{
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #F7F2EB;
		}
		::v-deep .el-table tbody .el-table__row:hover>td {
		    background-color: transparent !important;
		}
		::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{
			background-color: #F0E3D0;
		}
		::v-deep .el-table th.el-table__cell>.cell{
			word-break: break-work;
		}
		.pages{
			width: 100%;
			display: flex;
			justify-content: flex-end;
			padding-top: 40px;
			::v-deep .btn-prev{
				width: 30px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;	
				padding: 0;
			}
			::v-deep .el-icon{
				font-size: 12px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C1C1C1;
				text-align: center;
			}
			::v-deep .el-pager .number{
				width: 30px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;
				margin-left: 7px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5E5E5E;
				text-align: center;
				line-height: 30px;
				padding: 0;
			}
			::v-deep .el-pager .number.active{
				background: #5C707A;
				color: #FFFFFF;
			}
			::v-deep .btn-next{
				width: 30px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;	
				padding: 0;
				margin-left: 8px;
			}
			::v-deep .el-select{
				width: 90px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;
				margin-left: 15px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5E5E5E;
			}
			::v-deep .el-pagination .el-select .el-input{
				width: 100%;
				height: 100%;
				margin: 0;
			}
			::v-deep .el-pagination .el-select .el-input .el-input__inner{
				padding: 0 6px;
				border: none;
				background-color: #F7F2EB;
				height: 26px;
			}
			::v-deep .el-pagination__editor.el-input{
				width: 40px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5E5E5E;
				text-align: center;
				line-height: 30px;
				padding:0;
				
			}
			::v-deep .el-pagination__editor.el-input .el-input__inner{
				padding:0;
				background-color: #F7F2EB;
				border: none;
				height: 18px;
			}
		}
		
		.bottom_logo{
			margin-top: 70px;
			img{
				width: 55px;
				height: 18px;
				display: block;
				margin: 0 auto;
			}
		}
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		width:140%;
		background-color: rgba(0,0,0,0.3);
		z-index: 9999;
		.model_calendar{
			width: 1240px;
			min-height: 600px;
			// height: 1200px;
			overflow-y: scroll;
			background: #5C707A;
			box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
			border-radius: 10px;
			padding: 30px 20px;
			position: absolute;
			top: 200px;
			left: 50%;
			transform: translateX(-50%);
			.title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				margin-bottom: 20px;
			}
			.calendar_main{
				.select_list{
					.name{
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #F7F2EB;
						margin-right:50px;
						flex-shrink: 0;
					}
					.search{
						width: 208px;
						height: 50px;
						background: #FFFFFF;
						border: 1px solid #5C707A;
						border-radius: 25px;
						position: relative;
						flex-shrink: 0;
						input{
							width: 100%;
							height: 100%;
							font-size: 20px;
							font-family: Source Han Sans CN;
							font-weight: 200;
							color: #5C707A;
							line-height: 50px;
							padding: 0 50px 0 20px;
						}
						img{
							width: 25px;
							height: 25px;
							position: absolute;
							top: 50%;
							right: 10px;
							transform: translateY(-50%);
						}
					}
					.item{
						// padding: 0 10px;
						height: 50px;
						background: #FFFFFF;
						border-radius: 10px;
						margin-left: 20px;
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						img{
							width: 27px;
							height: 15px;
							margin-left: 10px;
						}
					}
				}
				::v-deep .el-select-dropdown__list{
					padding: 15px 0;
				}
				::v-deep .el-select{
					// width: 100%;
					height: 100%;
				}
				::v-deep .el-input.el-input--suffix{
					height: 100%;
				}
				::v-deep .el-input__icon{
					line-height: 56px;
				}
				::v-deep .el-input--suffix .el-input__inner{
					height: 100%;
					font-size: 18px;
					background-color: #F7F2EB;
					border: none;
					color: #282E30;
				}
				::v-deep .el-time-spinner__item{
					text-align: center;
				}
				::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
					width: 150px;
				}
				:v-deep .model .model_content .calendar_main[data-v-13306470] .el-input--suffix .el-input__inner{
					width: 150px;
				}
				.calendar_header{
					margin-top: 30px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #FFFFFF;
					cursor: pointer;
					img{
						width: 25px;
						height: 26px;
					}
					.left{
						span{
							margin-left: 10px;
						}
					}
					.right{
						span{
							margin-right: 10px;
						}
					}
				}
				.weeklist{
					margin-top: 30px;
					.weekName{
						.item{
							width: 150px;
							height: 60px;
							border: 1px solid #FFFFFF;
							border-radius: 10px;
							padding-left: 30px;
							font-size: 24px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #FFFFFF;
							line-height: 60px;
							.day{
								margin-left: 15px;
							}
						}
					}
					.course_list{
						margin-top: 20px;
						.day_item{
							width: 150px;
							.item{
								width: 100%;
								height: 200px;
								padding-top: 5px;
								background: #FFFFFF;
								font-size: 16px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #282E30;
								line-height: 30px;
								text-align: center;
								margin-bottom: 20px;
								border-radius: 10px;
								.time{
									text-align: center;
									
								}
								.place{
									text-align: center;
									height: 60px;
								}
								.info{
									height: 60px;
									background: #C98B2C;
									line-height: 26px;
									text-align: center;
									.name{
										text-align: center;
										height: 30px;
										overflow: hidden;
										text-overflow: ellipsis;
										white-space: nowrap;
									}
									.age{
										font-size: 12px;
										text-align: center;
									}
									&.red{
										background: #BF5F49;
									}
								}
								.tag{
									width: 90px;
									height: 26px;
									border: 1px solid #000000;
									border-radius: 13px;
									font-size: 12px;
									font-family: Source Han Sans CN;
									font-weight: 400;
									color: #000000;
									text-align: center;
									line-height: 26px;
									margin: 7px auto 0;
									cursor: pointer;
								}
							}
						}
					}
					
				}
			}
			.send{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #CCCCCC;
				margin-top: 100px;
				img{
					width: 16px;
					height: 16px;
					margin-right:10px;
				}
			}
			.submit_btn{
				width: 182px;
				height: 58px;
				background: #F7F2EB;
				border-radius: 29px;
				line-height: 58px;
				text-align: center;
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5C707A;
				margin: 20px auto;
			}
		}
	}
</style>